<div class="row">
    <div class="col-sm-12" *ngIf="tsStudent.editingMode !== 'addOrEdit'">
        <div class="col-sm-7 col-sm-offset-2">
            <input (ngModelChange)="toggleRegistrationStudent(tsStudent)"
                   [(ngModel)]="tsStudent.selected"
                   [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                   aria-label="checkbox-trainer"
                   *jhiHasAnyAuthority="'ROLE_ADMIN'">
            {{tsStudent.firstName}} {{tsStudent.lastName}}
            <span style="opacity: 0.7" *ngIf="tsStudent.email"> ({{tsStudent.email}}) </span>
        </div>

        <div class="col-sm-2">
            <span class="dropdown more-actions" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                <i class="fa fa-ellipsis-h on fa-circle"
                   type="button" id="more-menu-contact" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></i>
                <span class="dropdown-menu" aria-labelledby="more-menu-contact">
                    <li>
                    <a class="dropdown-item" (click)="studentEdition()">
                        <i class="fa fa-fw fa-pencil"></i> Modifier</a>
                    </li>
                    <li>
                    <a class="dropdown-item" (click)="openDeleteModal(deleteModal)">
                    <i class="fa fa-fw fa-trash"></i> Supprimer</a>
                    </li>
                </span>
            </span>
            &nbsp;&nbsp;
            <span class="{{getConvocationClass(tsStudent)}}">
                <i class="fa fa-envelope-o"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-bullhorn"></i>
            </span>
            <span class="{{getConventionClass(tsStudent)}}">
                <i class="fa fa-envelope-o"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-gavel"></i>
            </span>
        </div>
        <div>{{registrationDetailId}}</div>
        <div class="col-sm-1">
            <span class="registration-price">{{getDisplayedStudentPrice()}}</span>
        </div>
    </div>
</div>

<div class="col-sm-12 registration-edition" *ngIf="tsStudent.editingMode === 'addOrEdit'">
    <div class="col-sm-10 col-sm-offset-2">
        <registration-student-edition
            (getNewStudent)="getNewStudent($event)"
            [tsStudent]="tsStudent"
            [tsStudents]="tsStudents"
            [saving]="saving">
        </registration-student-edition>
    </div>
</div>


<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">Êtes-vous sur de vouloir supprimer ce stagiaire ?</h4>
    </div>
    <div class="modal-footer">
        <button style="margin-bottom: 0px" type="button" class="btn btn-default" (click)="closeDeleteModal()">Annuler
        </button>
        <button type="button" class="btn btn-primary" [disabled]="deleting" (click)="deleteRegistrationDetail(tsStudent)">
            <span *ngIf="deleting" class="fa fa-spinner fa-spin"></span> Supprimer
        </button>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/registration-student/registration-student.component.html